export default __webpack_public_path__ + "static/media/link.726653aa.svg";